import * as React from 'react'
import { useState } from 'react'
import { noop } from 'lodash'
import MediaQuery from 'react-responsive'
import { connect } from 'react-redux'
import {
  Text,
  StackChildren,
  Icon,
  InlineChildren,
  Breakpoints,
} from '@doordash/design-language'
import { RTIPrivacyFlow } from '../../../models/types'
import Button from '@doordash/component-button'
import * as api from '../../../api'
import * as events from '../../../events'
import * as DA from '../../../typeModules/events'
import ResponsiveWrapper from '../../atoms/responsive-wrapper'
import s from './strings'

type Props = {
  setView?: (view: RTIPrivacyFlow) => void
  trackRTI?: (data: DA.RTI) => void
}

export const RequestArchive: React.FC<Props> = ({
  setView = noop,
  trackRTI = noop,
}) => {
  const [loading, setLoading] = useState<boolean>(false)

  React.useEffect(() => {
    trackRTI({ action: DA.GDPRActions.Render })
  }, [trackRTI])

  const handleRequestArchiveOnClick = async () => {
    try {
      setLoading(true)
      await api.createDasherRTIRequest()
      trackRTI({ action: DA.GDPRActions.Submission })
      setView(RTIPrivacyFlow.PreparingArchive)
    } catch (e) {
      console.warn(e)
      trackRTI({ action: DA.GDPRActions.Error })
    } finally {
      setLoading(false)
    }
  }

  return (
    <ResponsiveWrapper>
      <StackChildren size={StackChildren.Sizes.Large}>
        <Text styles={Text.Styles.PageTitle2}>{s.title()}</Text>
        <Text styles={Text.Styles.Body1}>{s.subTitle()}</Text>
        <StackChildren size={StackChildren.Sizes.Large}>
          <InlineChildren size={InlineChildren.Sizes.XxSmall}>
            <Icon accessibilityLabel="" type={Icon.Types.PersonProfileLine} />
            <StackChildren size={StackChildren.Sizes.XxSmall}>
              <Text styles={Text.Styles.Label1Emphasis}>
                {s.personalInfoLabel()}
              </Text>
              <Text styles={Text.Styles.Body1}>{s.personalInfoText()}</Text>
            </StackChildren>
          </InlineChildren>
          <InlineChildren size={InlineChildren.Sizes.XxSmall}>
            <Icon accessibilityLabel="" type={Icon.Types.OrderBagLine} />
            <StackChildren size={StackChildren.Sizes.XxSmall}>
              <Text styles={Text.Styles.Label1Emphasis}>
                {s.orderInfoLabel()}
              </Text>
              <Text styles={Text.Styles.Body1}>{s.orderInfoText()}</Text>
            </StackChildren>
          </InlineChildren>
          <InlineChildren size={InlineChildren.Sizes.XxSmall}>
            <Icon accessibilityLabel="" type={Icon.Types.HelpLifesaver} />
            <StackChildren size={StackChildren.Sizes.XxSmall}>
              <Text styles={Text.Styles.Label1Emphasis}>
                {s.supportHistoryLabel()}
              </Text>
              <Text styles={Text.Styles.Body1}>{s.supportHistoryText()}</Text>
            </StackChildren>
          </InlineChildren>
        </StackChildren>
        <MediaQuery minWidth={Breakpoints.Mobile + 1}>
          <Button
            onClick={handleRequestArchiveOnClick}
            state={loading ? Button.States.Loading : Button.States.Default}
          >
            {s.button()}
          </Button>
        </MediaQuery>
      </StackChildren>
      <MediaQuery maxWidth={Breakpoints.Mobile}>
        <Button
          onClick={handleRequestArchiveOnClick}
          state={loading ? Button.States.Loading : Button.States.Default}
        >
          {s.button()}
        </Button>
      </MediaQuery>
    </ResponsiveWrapper>
  )
}

const mapDispatchToProps = {
  trackRTI: events.trackRTI,
}

export default connect(null, mapDispatchToProps)(RequestArchive)
